"use client";

import React, { useState, useEffect } from "react";
import { Layers, Globe, TrendingUp, ArrowUpRight, Activity, Zap } from "lucide-react";
import { Area, AreaChart, CartesianGrid, XAxis, ResponsiveContainer } from "recharts";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const chartData = [{
  month: "Jan",
  desktop: 186
}, {
  month: "Feb",
  desktop: 305
}, {
  month: "Mar",
  desktop: 237
}, {
  month: "Apr",
  desktop: 273
}, {
  month: "May",
  desktop: 309
}, {
  month: "Jun",
  desktop: 414
}];
const chartConfig = {
  desktop: {
    label: "Growth",
    color: "var(--chart-2)"
  }
} satisfies ChartConfig;
export default function MediaEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  return <section data-section-id="66901" id="the-ags-advantage" ref={ref} className={cn("w-full py-24 bg-background dark overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100" : "opacity-0")}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        
        {}
        <div className="mb-16 max-w-2xl">
          <h2 className="text-4xl md:text-5xl font-default font-semibold tracking-tight text-foreground mb-6">
            The AGS Advantage.
          </h2>
          <p className="text-xl text-muted-foreground font-default leading-relaxed">The ultimate Proven Business Growth System and CRM ecosystem for high-performance growth. Leverage the power of Automated Growth Systems with expert-led consult and turnkey automation.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 grid-rows-1 md:grid-rows-2 gap-6 h-auto md:h-[600px]">
          
          {}
          <div className="col-span-1 md:col-span-2 md:row-span-2 group">
            <Card className="h-full bg-card border border-white/10 shadow-sm hover:shadow-2xl hover:shadow-[#2D7FF9]/20 transition-all duration-500 hover:-translate-y-1 overflow-hidden rounded-[24px] relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#2D7FF9]/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              
              <CardHeader className="relative z-10 p-8 md:p-10">
                <div className="w-12 h-12 rounded-full bg-background/80 backdrop-blur-md flex items-center justify-center mb-6 shadow-sm border border-white/5">
                  <Layers className="w-6 h-6 text-[#2D7FF9] stroke-[1.5px] transition-all duration-500 group-hover:drop-shadow-[0_0_10px_rgba(45,127,249,0.8)]" />
                </div>
                <CardTitle className="text-3xl md:text-4xl font-default font-semibold tracking-tight text-foreground mb-4">Your Growth Engine: AGS</CardTitle>
                <CardDescription className="text-lg text-muted-foreground font-default max-w-md leading-relaxed">Harness a complete turnkey ecosystem designed for market dominance:<br />AI employees, 24x7 AI Receptionist, Missed Call SMS messaging,Lead Leak elimination, nurturing and maintaining customers to Social Media Review Management to SMS A2P-compliant messaging for high-velocity conversion, we fuel your growth.</CardDescription>
              </CardHeader>
              
              <CardContent className="relative z-10 p-8 md:p-10 pt-0 flex-1 flex items-end justify-end">
                {}
                <div className="relative w-48 h-48 md:w-64 md:h-64">
                  <div className="absolute inset-0 bg-gradient-to-tr from-[#2D7FF9]/20 to-[#BFFF00]/20 rounded-full blur-3xl animate-pulse" />
                  <div className="relative w-full h-full bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl shadow-2xl flex items-center justify-center transform rotate-[-12deg] group-hover:rotate-[-6deg] transition-transform duration-700 ease-out">
                    <Zap className="w-24 h-24 text-[#2D7FF9] stroke-[0.5px] drop-shadow-lg transition-all duration-500 group-hover:drop-shadow-[0_0_15px_rgba(45,127,249,0.9)]" />
                    <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent rounded-3xl pointer-events-none" />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="col-span-1 md:col-span-1 md:row-span-1 group">
            <Card className="h-full bg-card border border-white/10 shadow-sm hover:shadow-2xl hover:shadow-[#2D7FF9]/20 transition-all duration-500 hover:-translate-y-1 overflow-hidden rounded-[24px] flex flex-col">
              <CardHeader className="p-6 pb-2">
                <div className="flex items-center justify-between mb-2">
                  <div className="w-10 h-10 rounded-full bg-background/80 backdrop-blur-md flex items-center justify-center shadow-sm border border-white/5">
                    <Activity className="w-5 h-5 text-[#2D7FF9] stroke-[1.5px] transition-all duration-500 group-hover:drop-shadow-[0_0_10px_rgba(45,127,249,0.8)]" />
                  </div>
                  
                </div>
                <CardTitle className="text-xl font-default font-semibold tracking-tight text-foreground">
                  Performance Metrics
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 pt-0 flex-1 min-h-[160px] flex flex-col justify-end">
                {mounted ? <div className="w-full h-32 mt-auto">
                    <ChartContainer config={chartConfig} className="h-full w-full">
                      <AreaChart data={chartData} margin={{
                    top: 5,
                    right: 0,
                    left: 0,
                    bottom: 0
                  }}>
                        <defs>
                          <linearGradient id="fillDesktop" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="var(--color-secondary)" stopOpacity={0.3} />
                            <stop offset="95%" stopColor="var(--color-secondary)" stopOpacity={0} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="transparent" />
                        <XAxis dataKey="month" hide />
                        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                        <Area dataKey="desktop" type="natural" fill="url(#fillDesktop)" fillOpacity={0.4} stroke="var(--color-secondary)" strokeWidth={2} />
                      </AreaChart>
                    </ChartContainer>
                  </div> : <div className="w-full h-32 bg-muted/10 animate-pulse rounded-lg" />}
                <div className="mt-4 flex items-center gap-2 text-sm font-default font-medium text-[#BFFF00]">
                  <TrendingUp className="w-4 h-4" />
                  <span>+24.5% Growth</span>
                </div>
              </CardContent>
            </Card>
          </div>

          {}
          <div className="col-span-1 md:col-span-1 md:row-span-1 group">
            <Card className="h-full bg-card border border-white/10 shadow-sm hover:shadow-2xl hover:shadow-[#2D7FF9]/20 transition-all duration-500 hover:-translate-y-1 overflow-hidden rounded-[24px] relative">
              <div className="absolute top-0 right-0 p-6 opacity-50 group-hover:opacity-100 transition-opacity">
                <ArrowUpRight className="w-6 h-6 text-muted-foreground" />
              </div>
              
              <CardHeader className="p-6">
                <div className="w-10 h-10 rounded-full bg-background/80 backdrop-blur-md flex items-center justify-center mb-4 shadow-sm border border-white/5">
                  <Globe className="w-5 h-5 text-[#2D7FF9] stroke-[1.5px] transition-all duration-500 group-hover:drop-shadow-[0_0_10px_rgba(45,127,249,0.8)]" />
                </div>
                <CardTitle className="text-xl font-default font-semibold tracking-tight text-foreground">
                  SaaS Flexibility
                </CardTitle>
                <CardDescription className="text-muted-foreground font-default">
                  Scale effortlessly with our DFY, DWY, and DIY models tailored to your business stage.
                </CardDescription>
              </CardHeader>
              
              <CardContent className="p-6 pt-0 relative">
                <div className="relative mt-4">
                  {}
                  <div className="w-full h-32 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden relative">
                     <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(45,127,249,0.1),transparent)] opacity-50" />
                     <div className="grid grid-cols-6 gap-2 opacity-10 transform rotate-12 scale-150">
                        {Array.from({
                      length: 24
                    }).map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-primary" data-index={i} />)}
                     </div>
                     <div className="absolute w-24 h-24 rounded-full border border-[#2D7FF9]/30 flex items-center justify-center animate-[spin_10s_linear_infinite]">
                        <div className="w-16 h-16 rounded-full border border-[#2D7FF9]/50" />
                     </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}